import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Button,
  Box,
} from "@mui/material";
import { motion } from "framer-motion";

const advertisements = [
  {
    title: "Top Realtor of the Month",
    description: "Find your dream home with the best realtor in town!",
    image: "https://via.placeholder.com/150",
  },
  {
    title: "Experienced Broker Services",
    description: "Get the best deals on properties with our expert brokers.",
    image: "https://via.placeholder.com/150",
  },
  {
    title: "Trusted Agency",
    description: "Your trusted partner in finding the perfect property.",
    image: "https://via.placeholder.com/150",
  },
];

const cardVariants = {
  hidden: { opacity: 0, y: 50 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
  hover: { scale: 1.05, transition: { duration: 0.3 } },
};

const AdvertisementCard = ({ title, description, image }) => (
  <motion.div
    variants={cardVariants}
    initial="hidden"
    animate="visible"
    whileHover="hover"
  >
    <Card sx={{ maxWidth: 345, margin: "auto" }}>
      <Box
        component="img"
        src={image}
        alt={title}
        sx={{ height: 150, width: "100%", objectFit: "cover" }}
      />
      <CardContent>
        <Typography gutterBottom variant="h5" component="div">
          {title}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {description}
        </Typography>
        <Button variant="contained" color="primary" sx={{ mt: 2 }}>
          Learn More
        </Button>
      </CardContent>
    </Card>
  </motion.div>
);

const AdvertisementsBR = () => (
  <Grid container spacing={4} sx={{ padding: 4 }}>
    {advertisements.map((ad, index) => (
      <Grid item xs={12} sm={6} md={4} key={index}>
        <AdvertisementCard
          title={ad.title}
          description={ad.description}
          image={ad.image}
        />
      </Grid>
    ))}
  </Grid>
);

export default AdvertisementsBR;
